import { t } from 'i18next'

import { BookingAvailability } from '@/store/bookingAvailabilitySlice'
import { useAppDispatch, useAppSelector } from '../../../hooks/store'
import { cartSlice } from '../../../store/cartSlice/index'
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '../../Sheet/Sheet'
import { CartOverview } from '../CartOverview/CartOverview'
import { CartPopupContent } from '../CartPopupContent'

interface CartMobileSheetProps {
  nextPath?: string
}

export const CartMobileSheet = (props: CartMobileSheetProps) => {
  const dispatch = useAppDispatch()
  const cartPopoverIsOpen = useAppSelector(
    cartSlice.selectors.cartPopoverIsOpen
  )
  const selectedBookingType = useAppSelector(
    cartSlice.selectors.selectedBookingType
  )
  return (
    <Sheet
      onOpenChange={(open) =>
        dispatch(cartSlice.actions.setCartPopoverIsOpen(open))
      }
      open={cartPopoverIsOpen}
    >
      <SheetContent
        className="sticky overflow-auto rounded-t-lg pt-4 !shadow-none"
        mobileOnly
        showCloseButton={false}
      >
        <SheetTitle className="sr-only">
          {selectedBookingType === BookingAvailability.TICKETS
            ? t('common.tickets')
            : t('map.elementDetail.spot', { count: 2 })}
          {/* Please note: this count does not reflect a real dynamic value, we
          just needed any number greater than one to obtain the translation in
          plural form */}
        </SheetTitle>
        <SheetHeader />

        <div className="max-h-[60dvh] overflow-auto px-4">
          <CartPopupContent />
        </div>
        <CartOverview nextPath={props.nextPath} />
      </SheetContent>
    </Sheet>
  )
}
